import React from 'react';
import '../styles.css';
import poster from '../assets/images/poster.jpg';

const Shows = () => {
  return (
    <section id="upcoming-shows" className="section">
      
      <h2>Upcoming Shows</h2>
      <div className="show">
        <img src={poster} alt='poster'></img>
        <h1>Dayaben.com</h1>
        


        
        <p> The story revolves around Dayaben who is a simple homemaker and lives with her husband who considered her Naive.



The story line amid ups and downs, unfolds in an entertaining Tom and Jerry style entertainment on Dayaben dot com.



This hilarious comedy journey will bring you laughter and also have an important social message on woman empowerment, this show is a huge global success and is performed by prominent actors from Gujarati drama and movie Industry. 
        </p>
        
        <h3> London </h3>
        <p>Venue: Wolf Performance Hall <br>
        </br> Date:March 23, 2025<br></br>Showtime: 4:00 pm (EST)  <br></br> <a href="https://allevents.in/london/dayaben-dot-com/80003404619945">Buy Tickets</a></p>
        <h3> Mississauga</h3>
        <p>Venue: Meadowvale Theatre <br>
        </br> Date:March 30, 2025<br></br>Showtimes:<br></br> 3:00 pm (EST)  <br></br> <a href="https://www.ticketmaster.ca/event/10006238B1452448">Buy Tickets</a><br></br>
        7:00 pm (EST)<br></br><a href="https://www.ticketmaster.ca/event/10006238B1732450">Buy Tickets</a></p>

        
      </div>
    </section>
  );
}

export default Shows;
